import { CustomElement, resolve, watch } from 'aurelia';
import { AccountService, SavedSearchService } from '../../services';
import template from './save-search-modal.html';

// Modal for naming and saving the current filter state. Renders only while
// SavedSearchService.saveSearchOpen is set. Owns its own input focus: when the modal opens,
// it focuses and selects the seeded name so the user can accept or replace it immediately.
export class SaveSearchModalElement {
  readonly savedSearch: SavedSearchService = resolve(SavedSearchService);
  readonly account: AccountService = resolve(AccountService);
  saveSearchInput: HTMLInputElement | undefined;

  // Focus/select the seeded name whenever the modal transitions to open.
  @watch((vm: SaveSearchModalElement) => vm.savedSearch.saveSearchOpen)
  onOpenChanged(isOpen: unknown): void {
    if (!isOpen) return;
    // Defer until Aurelia has rendered the input into the DOM.
    setTimeout(() => {
      this.saveSearchInput?.focus();
      this.saveSearchInput?.select();
    });
  }
}

export const SaveSearchModal = CustomElement.define({
  name: 'save-search-modal',
  template
}, SaveSearchModalElement);
